
/*=========================================================================================
  File Name: modulekaindsGetters.js
  Description: kainds Module Getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/
export default {
  getMailSendResume: state => (id) => state.mailSendResumes.find(item => item.id === id)
}
